import { useState } from 'react'
import { propTypes } from '../../helpers'
import TagManager from 'react-gtm-module'
import {
  DropdownAccordion,
  Toolbar,
  VisualizationFactory
} from '../../components'
import { useVisualization, useVisualizations } from '../../hooks'
import { useApplicationName, useDisabled } from '../../store'
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'

const { env } = window
const VizualizationTitle = styled.div`
  font-size: 28px;
  padding-bottom: 0.5rem;
`

const pushGtmData = (category, action, label) => {
  env.gtmId &&
    TagManager.dataLayer({
      dataLayer: {
        event: 'gaEvent',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
      }
    })
}

const VisualizationPage = ({ category }) => {
  const [selected, setSelected] = useState()
  const applicationName = useApplicationName()
  const disabled = useDisabled()
  const { visualizations } = useVisualizations(category.id)
  const { visualization } = useVisualization(selected && selected.id)

  if (visualizations && !selected) {
    const storedVisualization = JSON.parse(
      window.localStorage.getItem(`SELECTED_VISUALIZATION_${category.id}`)
    )
    const selectedVisualization =
      visualizations.find((viz) => viz.id === storedVisualization?.id) ||
      visualizations[0]
    if (selectedVisualization) {
      pushGtmData(
        `${category.name} dropdown`,
        'Default',
        selectedVisualization.name
      )
      setSelected(selectedVisualization)
    }
  }

  const handleSelect = (item) => {
    window.localStorage.setItem(
      `SELECTED_VISUALIZATION_${category.id}`,
      JSON.stringify(item)
    )
    pushGtmData(`${category.name} dropdown`, 'Click', item.name)
    setSelected(item)
  }

  return (
    <>
      <Helmet>
        <title>
          {category.name} - {applicationName}
        </title>
      </Helmet>
      <Toolbar title={category.name}>
        {visualizations ? (
          <DropdownAccordion
            id='visualizationSelect'
            title='Select'
            options={visualizations}
            selectedOption={selected}
            onOptionSelect={handleSelect}
            variant='link'
            menuAlign={{ sm: 'left' }}
            disabled={disabled}
          />
        ) : null}
      </Toolbar>
      {selected ? (
        <VizualizationTitle>{selected.name}</VizualizationTitle>
      ) : null}
      {visualization ? (
        <VisualizationFactory visualization={visualization} />
      ) : null}
    </>
  )
}

VisualizationPage.propTypes = { category: propTypes.categoryPropType }

export { VisualizationPage }
